import * as React from 'react';
import {
  ContentClickedEventHandler,
  ContentTelemetryEventHandlers,
  ExploreDisplayMode,
  FavoriteToggleClickedEventHandler
} from '../../common/telemetryEvents/types/ContentTelemetryTypes';
import { IContentInfo } from '../../ts/models/IContentInfo';

export type ContentClickedChildFunction = (fn: ContentClickedEventHandler) => React.ReactElement;
export type ContentClickedTelemetryContextValueType = (childFunction: ContentClickedChildFunction) => React.ReactElement;
export type ContentClickedTelemetryContextType = React.Context<ContentClickedTelemetryContextValueType>;

export type FavoriteToggleClickedChildFunction = (fn: FavoriteToggleClickedEventHandler) => React.ReactElement;
export type FavoriteToggleClickedTelemetryContextValueType = (childFunction: FavoriteToggleClickedChildFunction) => React.ReactElement;
export type FavoriteToggleClickedTelemetryContextType = React.Context<FavoriteToggleClickedTelemetryContextValueType>;

export type TelemetryChildFunctions = (fn: ContentTelemetryEventHandlers) => React.ReactElement;
export type TelemetryContextTypes = ContentClickedTelemetryContextType | FavoriteToggleClickedTelemetryContextType;
export type TelemetryContextValues = ContentClickedTelemetryContextValueType | FavoriteToggleClickedTelemetryContextValueType;

// Telemetry Handler contexts
export const ContentClickedTelemetryContext: ContentClickedTelemetryContextType = React.createContext<ContentClickedTelemetryContextValueType>((childFunction) => childFunction(() => {}));
export const FavoriteToggleClickedTelemetryContext: FavoriteToggleClickedTelemetryContextType = React.createContext<FavoriteToggleClickedTelemetryContextValueType>((childFunction) => childFunction(() => {}));

/* Telemetry Data contexts */

// Common Contexts
export const ContentInfoContext: React.Context<IContentInfo> = React.createContext<IContentInfo>(null);

// Card releated data contexts
export const CardPositionContext: React.Context<number> = React.createContext<number>(null);

// Explore page related data contexts
export const ExplorePageDisplayModeContext: React.Context<ExploreDisplayMode> = React.createContext(null);

// Search 
export const SearchTermDataContext: React.Context<string> = React.createContext<string>(null);

/* END- Telemetry Data contexts */
